import PaginationTable from "./container"
import './style.scss'

/** 
 * @constructs PaginationTable
 * @module PaginationTable
 * @description 分頁式列表
 */

export default PaginationTable;